// src/components/layout/Navbar/CategoryNav.jsx

import React, { memo } from 'react';
import { IoLocationSharp } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import { setFilters } from '../../redux/auth/action/filtersActions';
import { useNavigate, useLocation } from 'react-router-dom';

// Memoize the component to prevent unnecessary re-renders
const CategoryNav = memo(({ categories }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // Access the current category filter from Redux store
  const currentCategoryFilter = useSelector((state) => state.filters.category);

  const handleCategoryClick = (categoryName) => {
    // Toggle category selection
    const newCategory = currentCategoryFilter === categoryName ? "" : categoryName;
    dispatch(setFilters({ category: newCategory }));
    
    // Navigate to home page if not already there
    if (location.pathname !== '/') {
      navigate('/');
    }
  };

  // Avoid rendering if categories is empty or not an array
  if (!categories || !Array.isArray(categories) || categories.length === 0) {
    return (
      <div className="hidden lg:flex justify-center bg-white px-2">
        <div className="text-sm text-gray-500 py-2">No categories available</div>
      </div>
    );
  }

  return (
    <div className="hidden lg:flex flex-wrap justify-center bg-white px-2 max-w-4xl">
      {categories.map((category) => {
        const isActive = currentCategoryFilter === category.category_name;
        return (
          <button
            key={category.category_id}
            onClick={() => handleCategoryClick(category.category_name)}
            className={`flex items-center p-1 px-3 mx-1 mt-2 rounded-full text-xs font-poppins border-2 transition-all duration-200 hover:scale-105 ${
              isActive
                ? 'bg-sunday_secondary text-white border-sunday_secondary shadow-md'
                : 'bg-white text-sunday_info border-sunday_secondary hover:bg-sunday_primary hover:text-white hover:border-sunday_primary'
            }`}
            title={`Filter by ${category.category_name}`}
          >
            {category.category_name}
          </button>
        );
      })}
      <button
        onClick={() => window.open("https://maps.google.com", "_blank")}
        className="flex items-center text-sunday_info p-1 px-3 mx-1 mt-2 rounded-full border-2 border-sunday_secondary text-xs font-poppins hover:bg-sunday_primary hover:text-white hover:border-sunday_primary transition-all duration-200"
        title="Search nearby locations"
      >
        <IoLocationSharp className="mr-1" /> Search Nearby
      </button>
    </div>
  );
});

CategoryNav.displayName = 'CategoryNav';

export default CategoryNav;
